webpackJsonp([112017176246455],{

/***/ 1948:
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ 1960:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // STYLE
	
	
	// LIBS
	
	
	__webpack_require__(1960);
	
	var _fp = __webpack_require__(11);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// DATA
	var teamMembers = __webpack_require__(1948).map(function (item) {
	  return _extends({}, item, { order: item.order || 100 });
	}).sort(function (a, b) {
	  return a.order - b.order;
	});
	
	// COMPONENTS
	
	
	var TeamMemberItem = function TeamMemberItem(teamMember, i) {
	  var imageURL = (0, _fp.get)('image.fields.file.url', teamMember);
	  return _react2.default.createElement(
	    'li',
	    { key: i },
	    _react2.default.createElement(
	      'article',
	      { className: 'cell', href: '#' },
	      _react2.default.createElement('img', { className: 'img', src: imageURL, alt: teamMember.name }),
	      _react2.default.createElement(
	        'span',
	        { className: 'text' },
	        _react2.default.createElement(
	          'div',
	          { className: 'primary-info' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'name' },
	            teamMember.name
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'title' },
	            teamMember.jobTitile
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'about' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'At Code Fellows, I: '
	            ),
	            teamMember.responsibility
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Students can talk to me about: '
	            ),
	            teamMember.studentsCanTalkToMeAbout
	          )
	        )
	      )
	    )
	  );
	};
	
	// INTERFACE
	var TeamPage = function TeamPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metaData2.default, { data: {
	        title: 'Meet Our Leadership Team | Code Fellows',
	        description: 'Meet the Code Fellows Leadership Team',
	        slug: 'meet-the-team'
	      } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'custom-page-header team-page-header' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Meet Our Leadership Team'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row team-page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'profiles' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'staff-profile' },
	          teamMembers.map(TeamMemberItem)
	        )
	      )
	    )
	  );
	};
	
	exports.default = TeamPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-meet-the-team-index-js-f870a7e53477dcfea644.js